export default class Plibel {
    switch1=false
    switch2=false
    switch3=false
    switch4=false
    switch5=false
    switch6=false
    switch7=false
    switch8=false
    switch9=false
    switch10=false
    switch11=false
    switch12=false
    switch13=false
    switch14=false
    switch15=false
    switch16=false
    switch17=false
    switch18=false
    switch19=false
    switch20=false
    switch21=false
    switch22=false
    switch23=false
    switch24=false
    switch25=false
    switch26=false
    switch27=false
    switch28=false
    switch29=false
    switch30=false
    switch31=false
    switch32=false
    switch33=false
    switch34=false
    switch35=false
    switch36=false
    switch37=false
    switch38=false
    switch39=false
    switch40=false
    switch41=false
    switch42=false
    switch43=false
    switch44=false
    switch45=false
    switch46=false
    switch47=false
    switch48=false
    switch49=false
    switch50=false
    switch51=false
    switch52=false
    switch53=false
    switch54=false
    switch55=false
    switch56=false
    switch57=false
    switch58=false
    switch59=false
    switch60=false
    switch61=false
    switch62=false
    switch63=false
    switch64=false
    switch65=false
    switch66=false
    switch67=false
    switch68=false
    switch69=false
    switch70=false
    switch71=false
    switch72=false
    switch73=false
    switch74=false
    switch75=false
    switch76=false
    switch77=false
    switch78=false
    switch79=false
    switch80=false
    switch81=false
    switch82=false
    switch83=false
    switch84=false
    switch85=false
    switch86=false
    switch87=false
    switch88=false
    switch89=false
    switch90=false
    switch91=false
    switch92=false
    switch93=false
    switch94=false
    switch95=false
    informacionLaboral=[
        {valor:"", descripcion:"", tipo:20 ,label:"a. Datos de filiación:", bold:false},
        {valor:"", descripcion:"", tipo:21 ,label:"      C.I.: 1721930442", bold:false},
        {valor:"", descripcion:"", tipo:22 ,label:"      Edad: 32", bold:false},
        {valor:"", descripcion:"", tipo:23 ,label:"      Apellidos y nombres: LOPEZ CRISTIAN", bold:false},
        {valor:"", descripcion:"", tipo:24 ,label:"      Empresa: PRIVADOS", bold:false},
        {valor:"", descripcion:"", tipo:25 ,label:"      Puesto de trabajo: PRIVADO", bold:false},
        ]    
}


// WEBPACK FOOTER //
// ./src/model/Plibel.js